// extracted by mini-css-extract-plugin
export default {"Tag":"Tag__Tag___yM4ND","input":"Tag__input___bhjCi","inner":"Tag__inner___Hfm5Z"};